import {
  FETCH_ALL,
  ADD_NEW,
  UPDATE,
  DELETE,
  GET_INVOICE,
  START_LOADING,
  END_LOADING,
  FETCH_INVOICE_BY_USER,
  FILTER_INVOICE,
  FETCH_INVOICE_BY_PRODUCT,
  FETCH_PAYMENT,
} from "../actions/constants";
import { parseISO, format } from "date-fns";
const user = JSON.parse(localStorage.getItem("profile"));
const invoices = (
  state = { isLoading: true, invoices: [], payment: {}, totalPages: 0 },
  action
) => {
  switch (action.type) {
    case START_LOADING:
      return { ...state, isLoading: true };
    case END_LOADING:
      return { ...state, isLoading: false };
    case FETCH_ALL:
      return {
        ...state,
        invoices: action.payload.data,
        currentPage: action.payload.currentPage,
        numberOfPages: action.payload.numberOfPages,
      };
    case FETCH_INVOICE_BY_USER:
      if (action.payload.role) {
        return {
          ...state,
          invoices: action.payload.data.filter(
            (invoice) =>
              invoice.assistant[0] === user?.result._id &&
              format(parseISO(invoice.createdAt), "yyyy-MM-dd") ===
                format(new Date(), "yyyy-MM-dd")
          ),
          totalPages: action.payload.totalPages,
        };
      } else {
        return {
          ...state,
          invoices: action.payload.data,
          totalPages: action.payload.totalPages,
        };
      }
    case FETCH_INVOICE_BY_PRODUCT:
      return { ...state, invoices: action.payload };

    case GET_INVOICE:
      return { ...state, invoice: action.payload };
    case ADD_NEW:
      return { ...state, invoices: [...state.invoices, action.payload] };
    case UPDATE:
      return {
        ...state,
        invoices: state.invoices.map((invoice) =>
          invoice._id === action.payload._id ? action.payload : invoice
        ),
      };
    case DELETE:
      return {
        ...state,
        invoices: state.invoices.filter(
          (invoice) => invoice._id !== action.payload
        ),
      };

    case FILTER_INVOICE:
      return {
        ...state,
        invoices: action.payload.data.filter(
          (item) =>
            format(parseISO(item.createdAt), "yyyy-MM-dd") >=
              action.payload.from &&
            format(parseISO(item.createdAt), "yyyy-MM-dd") <= action.payload.to
        ),
      };

    case FETCH_PAYMENT:
      return {
        ...state,
        payment: action.payload,
      };
    default:
      return state;
  }
};

export default invoices;

//   const invoices =( state = { invoices: [], }, action ) => {
//     switch (action.type) {
//         case FETCH_ALL:
//             return { ...state, invoices: action.payload }

//         case GET_INVOICE:
//             return { ...state, invoice: action.payload }

//         case ADD_NEW:
//             return { ...state, invoices: [...state.invoices, action.payload] }

//         case UPDATE:
//             return { ...state, invoices: state.invoices.map((invoice) => invoice._id === action.payload ? action.payload : invoice) }

//         case DELETE:
//         return {...state, invoices: state.invoices.filter((invoice) => invoice._id !== action.payload)}

//         default:
//             return state;
//     }
// }

// export default invoices
